import { type ClientUser } from '@models';
import { createEntityAdapter, type EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ClientUsersActions } from './client-users.actions';

export interface ClientUserState extends EntityState<ClientUser> {
  allUsersLoaded: boolean;
  isLoading: boolean;
  isResendInvitationLoading: boolean;
}

export const clientUserAdapter = createEntityAdapter<ClientUser>({});

export const initialClientUserState = clientUserAdapter.getInitialState({
  allUsersLoaded: false,
  isLoading: false,
  isResendInvitationLoading: false,
}) as ClientUserState;

export const clientUsersReducer = createReducer(
  initialClientUserState,

  on(ClientUsersActions.clientUsersLoaded, (state, action) => {
    return clientUserAdapter.setAll(action.clientUsersList, { ...state, allUsersLoaded: true });
  }),

  on(ClientUsersActions.clientUserCreated, (state, action) => {
    return clientUserAdapter.addOne(action.createdUser, { ...state, action, allUsersLoaded: true, isLoading: false });
  }),

  on(ClientUsersActions.addClientUser, state => {
    return { ...state, isLoading: true };
  }),

  on(ClientUsersActions.clientUserError, state => {
    return { ...state, isLoading: false };
  }),

  on(ClientUsersActions.updateUserClientSuccess, (state, action: { clientUser: ClientUser; }) => {
    return clientUserAdapter.updateOne(
      {
        changes: action.clientUser,
        id: action.clientUser.id,
      },
      { ...state },
    );
  }),

  on(ClientUsersActions.resetClientUsers, () => {
    return initialClientUserState;
  }),

  on(ClientUsersActions.resendUserInvitation, state => {
    return { ...state, isResendInvitationLoading: true };
  }),

  on(ClientUsersActions.resendUserInvitationSuccess, state => {
    return { ...state, isResendInvitationLoading: false };
  }),

  on(ClientUsersActions.resendUserInvitationError, state => {
    return { ...state, isResendInvitationLoading: false };
  }),

  on(ClientUsersActions.resetTotpSuccess, (state, action) => {
    return clientUserAdapter.updateOne(
      {
        changes: { totpEnabled: false, totpGracePeriodEndsAt: action.totpGracePeriodEndsAt },
        id: action.clientUser.id,
      },
      { ...state },
    );
  }),

  on(ClientUsersActions.assignNotificationTemplate, (state, action) => {
    return clientUserAdapter.updateMany(
      action.clientUsers.map(user => ({
        changes: { notificationTemplateId: action.templateId },
        id: user.id,
      })),
      state,
    );
  }),
);
